
namespace TabAurous.Inventory {
    import fld = MRPRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MRPGrid extends Serenity.EntityGrid<MRPRow, any> {
        protected getColumnsKey() { return 'Inventory.MRP'; }
        protected getDialogType() { return MRPDialog; }
        protected getIdProperty() { return MRPRow.idProperty; }
        protected getInsertPermission() { return MRPRow.insertPermission; }
        protected getLocalTextPrefix() { return MRPRow.localTextPrefix; }
        protected getService() { return MRPService.baseUrl; }
        private pendingChanges: Q.Dictionary<any> = {};
        public items = [];
        public priority : number;//to set the priority on button click
        constructor(container: JQuery) {
            super(container);
            this.setTitle("Material Requirement Planning");
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            var plugin = new Slick.ColumnGroup();//plugin to group
            
            var cols2 = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);
           // cols2 = cols2.filter(x => x.field != "Minimum1" && x.field != "Maximum1" && x.field != "Minimum2" && x.field != "Maximum2");

            //set groups for columns
            for (let col of cols2) {
                //console.log(col);
                if (col.field == "ProductCode" || col.field == "FixedCode") col.groupName = "Details";
                if (col.field == "Minimum0" || col.field == "Maximum0") col.groupName = "Priority 1";
                if (col.field == "Minimum1" || col.field == "Maximum1") col.groupName = "Priority 2";
                if (col.field == "Minimum2" || col.field == "Maximum2") col.groupName = "Priority 3";
                if (col.field == "InStock") col.groupName = "Stock";
                if (col.field == "InProcessQuantity" ) col.groupName = "In Process";
                if (col.field == "DifferenceQuantity" ) col.groupName = "Difference";
                if (col.field == "OrderQuantity") col.groupName = "Order";


            }
            grid.registerPlugin(plugin);

         //   plugin.enableColumnGrouping();
            //set priority to 1 by default on load
            cols2 = cols2.filter(x => x.field != "Minimum1" && x.field != "Maximum1" && x.field != "Minimum2" && x.field != "Maximum2");
            grid.setColumns(cols2);
            plugin.enableColumnGrouping();//enable the grouping
            this.priority = 0;
            return grid;
        }
        protected getButtons() {
            var _this = this;
            return [{
                title: 'Generate Material Requests',
                icon: 'fa fa-check-circle text-purple',
                onClick: () => {
                    // create new material requests
                    var items = this.items;
                    MaterialRequestService.CreateFromMRPReport(items,
                        response => {
                            Q.notifySuccess('Material Request Created Successfully');
                            this.refresh();
                    
                        },
                        { async: false });                  

                }
            }, {
                    title: 'Change Priority',
                    icon: 'fa fa-refresh text-blue',
                    
                    onClick: () => {
                        if (_this.priority == 0) {
                            var grid = super.createSlickGrid();
                            var plugin = new Slick.ColumnGroup();
                            grid.registerPlugin(plugin);

                            var columns = grid.getColumns();
                            var cols2 = columns.filter(x => x.field != "Minimum0" && x.field != "Maximum0" && x.field != "Minimum2" && x.field != "Maximum2");
                            for (let col of cols2) {
                                //console.log(col);
                                if (col.field == "ProductCode" || col.field == "FixedCode") col.groupName = "Details";
                                if (col.field == "Minimum0" || col.field == "Maximum0") col.groupName = "Priority 1";
                                if (col.field == "Minimum1" || col.field == "Maximum1") col.groupName = "Priority 2";
                                if (col.field == "Minimum2" || col.field == "Maximum2") col.groupName = "Priority 3";
                                if (col.field == "InStock") col.groupName = "Stock";
                                if (col.field == "InProcessQuantity") col.groupName = "In Process";
                                if (col.field == "DifferenceQuantity") col.groupName = "Difference";
                                if (col.field == "OrderQuantity") col.groupName = "Order";
                            }
                            grid.registerPlugin(plugin);
                            cols2 = cols2.filter(x => x.field != "Minimum0" && x.field != "Maximum0" && x.field != "Minimum2" && x.field != "Maximum2");
                            grid.setColumns(cols2);
                            plugin.enableColumnGrouping();
                            _this.priority = 1;
                            _this.view.params.Criteria = "0";
                            _this.refresh();
                        }
                        else if (_this.priority == 1) {
                            var grid = super.createSlickGrid();
                            var plugin = new Slick.ColumnGroup();
                            grid.registerPlugin(plugin);

                            var columns = grid.getColumns();
                            var cols2 = columns.filter(x => x.field != "Minimum0" && x.field != "Maximum0" && x.field != "Minimum1" && x.field != "Maximum1");
                            for (let col of cols2) {
                                if (col.field == "ProductCode" || col.field == "FixedCode") col.groupName = "Details";
                                if (col.field == "Minimum0" || col.field == "Maximum0") col.groupName = "Priority 1";
                                if (col.field == "Minimum1" || col.field == "Maximum1") col.groupName = "Priority 2";
                                if (col.field == "Minimum2" || col.field == "Maximum2") col.groupName = "Priority 3";
                                if (col.field == "InStock") col.groupName = "Stock";
                                if (col.field == "InProcessQuantity") col.groupName = "In Process";
                                if (col.field == "DifferenceQuantity") col.groupName = "Difference";
                                if (col.field == "OrderQuantity") col.groupName = "Order";
                            }
                            grid.registerPlugin(plugin);
                            cols2 = cols2.filter(x => x.field != "Minimum0" && x.field != "Maximum0" && x.field != "Minimum1" && x.field != "Maximum1");
                            grid.setColumns(cols2);
                            plugin.enableColumnGrouping();
                            _this.priority = 2;
                            _this.view.params.Criteria = "0";
                            _this.refresh();
                        } else if (_this.priority == 2) {
                            var grid = super.createSlickGrid();
                            var plugin = new Slick.ColumnGroup();
                            grid.registerPlugin(plugin);

                            var columns = grid.getColumns();
                            var cols2 = columns.filter(x => x.field != "Minimum1" && x.field != "Maximum1" && x.field != "Minimum2" && x.field != "Maximum2");
                            for (let col of cols2) {
                                if (col.field == "ProductCode" || col.field == "FixedCode") col.groupName = "Details";
                                if (col.field == "Minimum0" || col.field == "Maximum0") col.groupName = "Priority 1";
                                if (col.field == "Minimum1" || col.field == "Maximum1") col.groupName = "Priority 2";
                                if (col.field == "Minimum2" || col.field == "Maximum2") col.groupName = "Priority 3";
                                if (col.field == "InStock") col.groupName = "Stock";
                                if (col.field == "InProcessQuantity") col.groupName = "In Process";
                                if (col.field == "DifferenceQuantity") col.groupName = "Difference";
                                if (col.field == "OrderQuantity") col.groupName = "Order";


                            }
                            grid.registerPlugin(plugin);
                            cols2 = cols2.filter(x => x.field != "Minimum1" && x.field != "Maximum1" && x.field != "Minimum2" && x.field != "Maximum2");
                            grid.setColumns(cols2);
                            plugin.enableColumnGrouping();
                            _this.view.params.Criteria = "0";
                            _this.priority = 0;
                            _this.refresh();
                        }

                    }
                }]
        }

        protected getColumns() {
            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            
            Q.first(columns, x => x.field === fld.OrderQuantity).format = num;

            return columns;
        }
   
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');

            var id = item.DetailsId;

            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value; 

            /*** Validate Decimal & Integer***/
            if (field === fld.OrderQuantity) {
                value = Q.parseDecimal(text);
                if (item.DifferenceQuantity < 0) {
                    Q.notifyError('Excess Stock Not Allowed');
                    input.val(oldText);
                    input.focus();
                    return;
                }
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            //// *** Update , Amount etc on  Change***
            if (field === fld.OrderQuantity) {
                item[field] = value;

                this.view.updateItem(id, item);
                this.view.refresh();
                this.items.push(item);
                //   }

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.Net * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            //if (field === fld.Discount && value >= 0) {
            //    item.GrossAmount = item.NetAmount - value;
            //    item[field] = value;

            //}

            //// *** Set CalcOn ***
            //if (field === fld.UOM && value > 0) {
            //    item[field] = value;

            //}

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            //var id = this.id(item);
            //var pending = this.pendingChanges[id];
            //if (pending && pending[field] !== undefined) {
            //    return pending[field];
            //}
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
    }
}